import { endpointsArticlesDocuments, endpointsArticles } from '../api/endpoints'
import { API } from './comunApi'

export const articlesApi = {
  getInfoArticle: (id) => {
    return API.get(endpointsArticles.GET_INFO_ARTICLE_BY_ID(id))
  },
  getAllFinalProducts: async () => {
    console.log("getAllFinalProducts called");
    return await API.get(endpointsArticles.GET_ALL_FINAL_PRODUCTS)
  },
  getAllFolderProducts: async () => {
    console.log("getAllFolderProducts called");
    return await API.get(endpointsArticles.GET_ALL_FOLDER_PRODUCTS)
  },
  // Búsqueda global de productos finales por nombre o referencia
  getAllFinalProductsBySearch: async (search, page, filterBusinessUnits) => {
    console.log("getAllFinalProductsBySearch", "search", search, "page", page, "filterBusinessUnits", filterBusinessUnits);
    return await API.get(
      endpointsArticles.GET_ALL_FINAL_PRODUCTS_BY_SEARCH(search, page, filterBusinessUnits),
    )
  },
  // Búsqueda global de productos folder por nombre o referencia
  getAllFolderProductsBySearch: async (search, page, filterBusinessUnits) => {
    console.log("getAllFolderProductsBySearch", "search", search, "page", page, "filterBusinessUnits", filterBusinessUnits);
    return await API.get(
      endpointsArticles.GET_ALL_FOLDER_PRODUCTS_BY_SEARCH(search, page, filterBusinessUnits),
    )
  },
  // Devulve los articulos de una categoria que no tienen padre
  getArticlesByCategoryId: async (idCategory, filterBusinessUnits) => {

    return await API.get(
      endpointsArticles.GET_ALL_ARTICLES_OF_A_CATEGORY(idCategory, filterBusinessUnits),
    )
  },
  // todos los articulos de una categoria que no tienen padre, es decir primer nivel
  getArticlesOfAFatherId: async (idFatherId, filterBusinessUnits) => {
    console.log("getArticlesOfAFatherId called", "idFatherId", idFatherId, "filterBusinessUnits", filterBusinessUnits);
    return await API.get(
      endpointsArticles.GET_ALL_ARTICLES_OF_A_FATHER(idFatherId, filterBusinessUnits),
    )
  },
  // Devuelve todos los articulos de una categoria que no son producto final.
  getAllArticleByCategoryId: async (idCategory, filterBusinessUnits) => {
    return await API.get(
      endpointsArticles.GET_ALL_ATICLES_BY_ID_CATEGORY(idCategory, filterBusinessUnits),
    )
  },
  deleteArticles: async (id) => {
    return await API.delete(endpointsArticles.DELETE_ARTICLES(id))
  },

  updateArticles: async (params) =>
    API.put(endpointsArticles.UPDATE_ARTICLES, params),
  newArticle: (params) => API.post(endpointsArticles.NEW_ARTICLES, params),
  // ARTICLES DOCUMENTS
  getalldocuementscascadeupper: async (id) => {
    return await API.get(
      endpointsArticlesDocuments.GET_ALL_DOCS_CASCADE_UPPER(id),
    )
  },
  getArticleCoverImg: async (id) => {
    return await API.get(endpointsArticlesDocuments.GET_ARTICLE_COVER_IMG(id))
  },
  getArticleImgs: async (id) => {
    return await API.get(endpointsArticlesDocuments.GET_ARTICLE_IMGS(id))
  },
  deleteArticlesDocuments: async (id) => {
    return await API.delete(
      endpointsArticlesDocuments.DELETE_ARTICLE_DOCUMETNS(id),
    )
  },
  deleteArticlesDocumentsByName: async ({ id, name, isImagenPortada }) => {
    return await API.delete(
      endpointsArticlesDocuments.DELETE_ARTICLE_DOCUMENTS_BY_NAME(id, name, isImagenPortada),
    )
  },
  // Le mandas una ruta ftp y te devuelve STREAM
  getFile: async (params) => {
    return await API.put(endpointsArticlesDocuments.GET_FILE, params, {
      responseType: 'arraybuffer',
    })
  },
  uploadFiles: (params) => {
    return API.post(endpointsArticlesDocuments.UPLOAD_FILES, params, {
      headers: { 'content-type': 'multipart/form-data' },
    })
  },
}
